<form [formGroup]="addressForm">
    @if (!editMode()) {
        <div fxLayout fxLayoutAlign="space-between end" class="p-b-sm" data-testid="cipo-address-form-view-mode">
            @if (!multiple() && address()) {
                <div>{{ addressService.formatAddress(address(), displayTypeReadOnly()) }}</div>
            }
            @if (!multiple() && address()?.lat && address()?.lon) {
                <div>{{ addressService.formatPosition(address()) }}</div>
            }
        </div>
    } @else {
        <div fxLayout fxLayoutAlign="start start" fxLayoutGap="8px">
            <mat-form-field data-testid="cipo-address-form-address" fxFlex appearance="outline">
                <mat-label>
                    {{ "MODULE_DEF_ADDRESS.ADDRESS_LABEL" | translate }}
                </mat-label>
                <input matInput aria-label="Address" [matAutocomplete]="auto" formControlName="address" />
                <mat-autocomplete
                    #auto="matAutocomplete"
                    data-testid="cipo-address-form-address-autocomplete"
                    (optionSelected)="onOptionSelected($event)"
                    [displayWith]="getAddressText">
                    @if (addressResults$ | async; as addressResults) {
                        @if (addressResults.length > 0) {
                            @for (addressResult of addressResults; track addressResult.position) {
                                <mat-option
                                    data-testid="cipo-address-form-address-autocomplete-option"
                                    [value]="addressResult"
                                    (click)="$event.stopPropagation()">
                                    <span>{{ addressResult.address.freeformAddress }}</span>
                                </mat-option>
                            }
                        } @else {
                            <mat-option data-testid="cipo-address-form-address-autocomplete-no-suggestions" disabled>
                                {{ "MODULE_DEF_ADDRESS.NO_SUGGESTIONS" | translate }}
                            </mat-option>
                        }
                    }
                </mat-autocomplete>
                @if (addressForm.controls.address.hasError("required")) {
                    <mat-error>
                        {{ "errors.required" | translate }}
                    </mat-error>
                }
            </mat-form-field>
            <mat-form-field data-testid="cipo-address-form-location-name" fxFlex="20%" appearance="outline">
                <mat-label>
                    {{ "MODULE_DEF_ADDRESS.LOCATION_LABEL" | translate }}
                </mat-label>
                <input matInput aria-label="Address" formControlName="locationName" />
                @if (addressForm.controls.locationName.hasError("required")) {
                    <mat-error>
                        {{ "errors.required" | translate }}
                    </mat-error>
                }
            </mat-form-field>
            <mat-form-field data-testid="cipo-address-form-lat" fxFlex="160px" appearance="outline">
                <mat-label>
                    {{ "MODULE_DEF_ADDRESS.LATITUDE_LABEL" | translate }}
                </mat-label>
                <input matInput formControlName="lat" />
                @if (addressForm.controls.lat.hasError("required")) {
                    <mat-error>
                        {{ "errors.required" | translate }}
                    </mat-error>
                }
            </mat-form-field>
            <mat-form-field data-testid="cipo-address-form-lon" fxFlex="160px" appearance="outline">
                <mat-label>
                    {{ "MODULE_DEF_ADDRESS.LONGITUDE_LABEL" | translate }}
                </mat-label>
                <input matInput formControlName="lon" />
                @if (addressForm.controls.lon.hasError("required")) {
                    <mat-error>
                        {{ "errors.required" | translate }}
                    </mat-error>
                }
            </mat-form-field>
        </div>
    }
</form>
